<template>
  <footer>
    <div class="box-accesos">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 hidden-xs hidden-sm">
            <div class="logo">

            </div>
          </div>

          <div class="col-lg-3">
            <ul>
              <li>CONTACTANOS.</li>


              <li>E-mail: <a href="mailto:ventas@martaroggiero.com.ar">ventas@martaroggiero.com.ar</a></li>
              <li><a href="https://wa.link/l5t5lb" target="_blank">Whatsapp. 54 9 (11) 6801-7957</a></li>
              <li>Tel. (11) 2150-5510</li>
            </ul>
          </div>
            <div class="col-lg-3">
                <ul>
                    <li>MARTA ROGGIERO STORE</li>
                    <li>Lun. a Vie. de 8 a 17hs</li>
                    <li>Independencia 160, Avellaneda.</li>
                    <li>BS AS, Argentina.</li>
                </ul>
            </div>
          <div class="col-lg-3">
            <ul>
              <li>SEGUINOS.</li>
              <li><a href="https://www.facebook.com/martaroggiero" target="_blank"><i class="fa fa-facebook"></i> &nbsp; Facebook</a></li>
              <li><a href="http://instagram.com/martaroggiero" target="_blank"><i class="fa fa-instagram"></i> &nbsp; Instagram</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="box-certificados">
      <div class="container">

        <ul>

          <li><a href="http://qr.afip.gob.ar/?qr=DwWXuWfvee3edOKwD7HReA,,"  target="_F960AFIPInfo"><img src="/static/img/app/logo-afip.png"></a></li>
        </ul>
        <div class="clear"></div>

      </div>
    </div>
  </footer>

</template>

<script>
    export default {
        name: "FooterPartial"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FooterPartial.vue